import { PreventDefaultEventWithReturnValue } from '../../types/common';

const createBeforeUnloadManager = () => {
  let message = '';

  const setMessage = (newMessage: string) => {
    message = newMessage;
  };

  const clearMessage = () => {
    message = '';
  };

  const handler = (event: PreventDefaultEventWithReturnValue) => {
    event.preventDefault();
    return event.returnValue = message;
  };

  const attach = () => {
    window.addEventListener('beforeunload', handler);
  };

  const detach = () => {
    global?.window && window.removeEventListener('beforeunload', handler);
    clearMessage();
  };

  return {
    setMessage,
    clearMessage,
    handler,
    attach,
    detach,
  };
};

export const beforeUnloadManager = createBeforeUnloadManager();
